import { i18n } from '@I18n/index'
import { Lang } from "@Enums/lang"

export class LangHelper {
  public static updateLang(lang: Lang) {
		i18n.locale = lang
		document.documentElement.setAttribute('lang', lang)
	}
}